module.exports = __webpack_public_path__ + "static/media/elfsquad.9f05c880.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/elfsquad.webp
// module id = 425
// module chunks = 0